/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//挑战不可能
const challenge = require('appComp/page/challenge/challenge-layout/challenge-layout');
const challengeList = require('appComp/page/challenge/challenge-list/challenge-list');

module.exports = {
  component: challenge,
  subRoutes: {
    "/challenge-list": {
    	component: challengeList,
      name:"challengeList",
      title: "作品管理"
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/challenge.js